const INIT_STATE = {
    reportList: [],
    apiFail: false,
    patientModelVisible: false,
    reportDetails: null,
    patientReportData: null,
    spinner: false,
    accountManagers: [],
    reportRead: false,
    reportListSpinner: false,
    accountManagersList : []
}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'gettingReportListSpinner_START': {
            return {
                ...state,
                reportListSpinner: true
            }
        }
        case 'getReportList_SUCCESS':
            const accountManagers = getAccountManagers(action.payload.Record)
            return {
                ...state,
                reportList: action.payload.Record,
                apiFail: false,
                accountManagers: [...accountManagers],
                reportListSpinner: false
            }

        case 'getManagerDropdown_SUCCESS': {
            return {
                ...state,
                accountManagersList: action.payload.Record
            }
        }
        case 'getReportList_FAILURE':
            return {
                ...state,
                textMessage: 'could not fetch reports list due to some error',
                apiFail: true,
                reportListSpinner: false

            }
        case 'patientReport_Modal': {
            return {
                ...state,
                patientModelVisible: !state.patientModelVisible,
                reportDetails: action.payload ? action.payload : '',
                apiFail: false
            }
        }
        case 'resetRportList': {
            return {
                ...state,
                apiFail: false,
                spinner: false,
                reportRead: false,
                reportListSpinner: false
            }

        }
        case 'gettingReportList_START': {
            console.log('==========getPatientReport_START')
            return {
                ...state,
                spinner: true
            }
        }
        case 'getPatientReport_SUCCESS': {

            return {
                ...state,
                patientReportData: action.payload.Record[0],
                spinner: false
            }
        }
        case 'updateReportStatus_SUCCESS': {
            return {
                ...state,
                reportRead: true
            }
        }
        // case 'getAccountManager_SUCCESS': {
        //     return {
        //         ...state,
        //         accountManagers: action.payload.Record
        //     }
        // }

        default:
            return state
    }
}

const getAccountManagers = (oldArray) => {

    let uniqueArray = []
    const result = oldArray.filter((item) => {


        if (uniqueArray.includes(item.accountManagerName || item.accountManagerFullName)) {
            return false
        }
        else {
            uniqueArray.push(item.accountManagerName || item.accountManagerFullName)
            return true
        }

    })

    return result

}


